import { DB_Init } from "../../DBSlice/SliceDB";
import { Logout } from "../Login/sliceUsers";
import { ClearGrnGrnNavBtnSlice } from "../Grn/SliceGRNNavBtn";
import { ClearGrnModelCheckbox } from "../Grn/sliceGrnCheckout";
import { GrnLocation_Init } from "../../DBSlice/SliceGRNLocation";
import { GrnLocationGroup_Init } from "../../DBSlice/SliceGRNLocationGroup";
import { GrnTax_Init } from "../../DBSlice/SliceTax";
import { GrnConfiguration_Init } from "../Grn/SliceGRNConfiguration";
import { GrnDetail_Init } from "../Grn/SliceGRNDetail";
import { BufferObj_Init } from "../Grn/SliceGRNDetail";
import { GrnHead_Init } from "../Grn/SliceGRNHead";
import { Bintransfer_Init } from "../BinTransfer/SliceBinTransfer";
import { InstantPicking_Init } from "../Instant/SliceInstantPickingHead";
import { Picking_Init } from "../Picking/SlicePickingHead";
import { ClearWmsInvoiceTag } from "../WMSSalesInvoice/sliceWmsInvoiceTag";
import { WmsInvoice_Init } from "../WMSSalesInvoice/SliceWmsInvoice";
import { SalesQuotation_Init } from "../SalesQuotation/SliceSalesQuotation";
import { SalesOrder_Init } from "../SalesOrder/SliceSalesOrder";
import { Set_SalesInvoice_Init } from "../SalesInvoice/SliceSalesInvoice";
import { Dispatch_Init } from "../Dispatch/SliceDispatch";
import { Loading_Init } from "../Loading/SliceLoading";
import { EasyLoading_Init } from "../EasyLoading/SliceEasyLoading";
import { Notification_Init } from "../Notification/SliceNotification";
import { Set_WmsInboundGRN_HeadObject_Init } from "../InboundGRN/SliceWmsInboundGRN";
import { Set_WmsOutboundGRV_Init } from "../OutboundGRV/SliceWmsOutboundGRV";
import { Set_WmsStockTransfer_Init } from "../StockTransfer/SliceWmsStockTransfer";
import { Set_WmsStockAdjustment_Init } from "../StockAdjustment/SliceWmsStockAdjustment";
import { Set_LoadingList_Init } from "../LoadingList/SliceLoadingList";
import { Set_WmsLoadingReceipt_Init } from "../LoadingReceipt/SliceWmsLoadingReceipt";
import { Set_bin_Init } from "../bin/Slicebin";
import { Set_Driver_Init } from "../Driver/SliceDriver";
import { Set_Truck_Init } from "../Truck/SliceTruck";
import { SliceWmsPhysicalStockCount_Init } from "../WmsPhysicalStockCount/SliceWmsPhysicalStockCount";
import { SliceWmsPoPhysicalStockCount_Init } from "../WmsPoPhysicalStockCount/SliceWmsPoPhysicalStockCount";
import { SliceCyclecount_Init } from "../CycleCount/SliceCyclecount";
import { SlicePutAway_Init } from "../PutAway/SlicePutAway";

import { Set_DCRequest_Init } from "../DCRequest/SliceDCRequest";
import { Set_WMSStockReport_Init } from "../WMSStockReport/SliceWMSStockReport";
import { Slice_StockTransferReceipt_Init } from "../StockTransferReceipt/SliceStockTransferReceipt";
import { Slice_PhysicalStock_Init } from "../PhysicalStock/SlicePhysicalStock";
import { EasyBinTransfer_Init } from "../EasyBinTransfer/SliceEasyBinTransfer";
import { Set_WmsDashboard_Init } from "../WmsDashboard/SliceWmsDashboard";
import { Set_SalesReturn_Init } from "../SalesReturn/SliceSalesReturn";
import { Segregation_Init } from "../Segregation/SliceSegregation";
import { Set_StockTransfer_Init } from "../StockTransferNormal/SliceStockTransfer";
import { Barcode_Init } from "../BarcodeScanning/SliceBarcodeScanning";
import { Set_StockAdjustment_Init } from "../StockAdjustmentNormal/SliceStockAdjustment";
import { Set_DelieveryNote_Init } from "../DelieveryNote/SliceDelieveryNote";
import { Set_PurchaseOrder_Init } from "../PurchaseOrder/SlicePurchaseOrder";
import { Slice_BatchOut_Init } from "../BatchOut/SliceBatchOut";
import { ItemCreationRequest_Init } from "../ItemCreationRequest/SliceItemCreationRequest";
import { Set_WmsInboundVendor_Init } from "../WmsInboundVendor/SliceWmsInboundVendor";
import { Set_WmsInboundReturn_Init } from "../WmsInboundReturn/SliceWmsInboundReturn";
import { Set_WmsInboundOutlet_Init } from "../WmsInboundOutlet/SliceWmsInboundOutlet";
import { Set_StockTransferRequest_Init } from "../StockTransferRequest/SliceStockTransferRequest";
import { StockSetupChangeRequest_Init } from "../StockSetupChangeRequest/SliceStockSetupChangeRequest";
import { StockSetupChangeApprove_Init } from "../StockSetupChangeApprove/SliceStockSetupChangeApprove";
import { VendorDiscontinueChangeRequest_Init } from "../VendorDiscontinueChangeRequest/SliceVendorDiscontinueChangeRequest";
import { VendorDiscontinueChangeApprove_Init } from "../VendorDiscontinueChangeApprove/SliceVendorDiscontinueChangeApprove";

export const clearSlice = (dispatch, navigate) => {
  if(navigate !=""){
    navigate("/Login");
  }
 
  dispatch(Logout({}));

  dispatch(ClearGrnGrnNavBtnSlice());
  dispatch(ClearGrnModelCheckbox());
  dispatch(GrnLocation_Init());
  dispatch(Set_PurchaseOrder_Init());
  dispatch(GrnLocationGroup_Init());
  dispatch(GrnTax_Init());
  dispatch(GrnConfiguration_Init({}));
  dispatch(GrnDetail_Init({}));
  dispatch(BufferObj_Init());
  dispatch(GrnHead_Init());
  dispatch(Bintransfer_Init());
  dispatch(InstantPicking_Init());
  dispatch(Picking_Init());
  dispatch(ClearWmsInvoiceTag());
  dispatch(WmsInvoice_Init());
  dispatch(SalesQuotation_Init());
  dispatch(SalesOrder_Init());
  dispatch(Dispatch_Init());
  dispatch(EasyBinTransfer_Init());
  dispatch(Loading_Init());
  dispatch(EasyLoading_Init());
  dispatch(Notification_Init());
  dispatch(Segregation_Init());
  // dispatch(Set_WmsInboundGRN_Init());
  dispatch(Set_WmsInboundGRN_HeadObject_Init());
  dispatch(Set_WmsInboundVendor_Init());
  dispatch(Set_WmsInboundReturn_Init());
  dispatch(Set_WmsInboundOutlet_Init());
  dispatch(Set_WmsOutboundGRV_Init());
  dispatch(Set_WmsStockTransfer_Init());
  dispatch(Set_StockTransfer_Init());
  dispatch(Set_StockAdjustment_Init());
  dispatch(DB_Init());
  dispatch(Set_LoadingList_Init());
  dispatch(Set_WMSStockReport_Init());
  dispatch(Set_WmsLoadingReceipt_Init());
  dispatch(Set_bin_Init());
  dispatch(Set_Driver_Init());
  dispatch(Set_WmsDashboard_Init());
  dispatch(Set_Truck_Init());
  dispatch(Set_WmsStockAdjustment_Init());
  dispatch(Set_SalesInvoice_Init());
  dispatch(Set_SalesReturn_Init());
  dispatch(Set_DelieveryNote_Init());
  dispatch(SliceWmsPhysicalStockCount_Init());
  dispatch(SliceWmsPoPhysicalStockCount_Init());
  dispatch(SliceCyclecount_Init());
  dispatch(SlicePutAway_Init());
  dispatch(Set_DCRequest_Init());
  dispatch(Slice_StockTransferReceipt_Init());
  dispatch(Slice_PhysicalStock_Init());
  dispatch(Barcode_Init());
  dispatch(Slice_BatchOut_Init());
  dispatch(ItemCreationRequest_Init());
  dispatch(Set_StockTransferRequest_Init());
  dispatch(StockSetupChangeRequest_Init());
  dispatch(StockSetupChangeApprove_Init());
  dispatch(VendorDiscontinueChangeRequest_Init());
  dispatch(VendorDiscontinueChangeApprove_Init());
};

export const LayoutSideMenuTransaction = [
  { displayName: "delivery", routeName: "/deliverySummary", hide: false },
  { displayName: "EasyBinTransferSummary", routeName: "/EasyBinTransferSummary", hide: false },
  { displayName: "Wms Inbound GRN", routeName: "/WmsInboundGRN", hide: false },
  {
    displayName: "DCItemsPriority",
    routeName: "/DCItemsPriority",
    hide: false,
  },
  {
    displayName: "Wms Outbound GRV",
    routeName: "/WmsOutboundGRV",
    hide: false,
  },
  {
    displayName: "Wms Stock Transfer",
    routeName: "/WmsStockTransfer",
    hide: false,
  },
  {
    displayName: "Wms Stock Adjustment",
    routeName: "/WmsStockAdjustment",
    hide: false,
  },
  {
    displayName: "SalesGroupUpdate",
    routeName: "/SalesGroupUpdate",
    hide: false,
  },
  { displayName: "Stock Enquiry", routeName: "/StockEnquiry", hide: false },
  { displayName: "InstantPicking", routeName: "/InstantPicking", hide: false },
  { displayName: "WMSDispatch", routeName: "/WMSDispatch", hide: false },
  { displayName: "Loading", routeName: "/Loading", hide: false },
  { displayName: "EasyLoading", routeName: "/EasyLoading", hide: false },
  { displayName: "DoStamping", routeName: "/DoStamping", hide: false },
  { displayName: "Loading List", routeName: "/LoadingList", hide: false },
  {
    displayName: "Do Receipt",
    routeName: "/WmsLoadingReceipt",
    hide: false,
  },
  {
    displayName: "Bin",
    routeName: "/binMaster",
    hide: false,
  },
  {
    displayName: "Driver",
    routeName: "/driver",
    hide: false,
  },
  {
    displayName: "WmsDashoard",
    routeName: "/wmsDashoard",
    hide: false,
  },
  {
    displayName: "Truck",
    routeName: "/truck",
    hide: false,
  },
  { displayName: "Notification", routeName: "/Notification", hide: false },
  { displayName: "Bin Transfer", routeName: "/BinTransferData", hide: false },
  {
    displayName: "Wms Sales Invoice",
    routeName: "/WmsSalesInvoice",
    hide: false,
  },

  {
    displayName: "WmsPoPhysicalStock",
    routeName: "/WmsPoPhysicalStock",
    hide: false,
  },
  {
    displayName: "SalesInvoice",
    routeName: "/SalesInvoice",
    hide: false,
  },
  {
    displayName: "Setting",
    routeName: "/WmsPhysicalStock",
    hide: false,
  },
  {
    displayName: "Counting",
    routeName: "/WmsPhysicalStockCount",
    hide: false,
  },
  { displayName: "PutAway", routeName: "/PutAway", hide: false },
  { displayName: "EasyPutAway", routeName: "/EasyPutAway", hide: false },
  {
    displayName: "WMSStockReport",
    routeName: "/WMSStockReport",
    hide: false,
  },
  {
    displayName: "WMSSalesReport",
    routeName: "/WMSSalesReport",
    hide: false,
  },
  {
    displayName: "PendingDoDetailReport",
    routeName: "/PendingDoDetailReport",
    hide: false,
  },
  {
    displayName: "TransDetailReport",
    routeName: "/TransDetailReport",
    hide: false,
  },

  {
    displayName: "DcCostCompareHistoryReport",
    routeName: "/DcCostCompareHistoryReport",
    hide: false,
  },
  {
    displayName: "OutletPlanningReport",
    routeName: "/OutletPlanningReport",
    hide: false,
  },
  {
    displayName: "PoCostCompareReport",
    routeName: "/PoCostCompareReport",
    hide: false,
  },
  {
    displayName: "BranchToDcTsrDetailReport",
    routeName: "/BranchToDcTsrDetailReport",
    hide: false,
  },
  {
    displayName: "DcItemsStatusReport",
    routeName: "/DcItemsStatusReport",
    hide: false,
  },
  {
    displayName: "DCRequest",
    routeName: "/DCRequest",
    hide: false,
  },
  {
    displayName: "SalesQuotation",
    routeName: "/SalesQuotation",
    hide: false,
  },
  {
    displayName: "SalesOrder",
    routeName: "/SalesOrder",
    hide: false,
  },
  { displayName: "Picking", routeName: "/Picking", hide: false },
  {
    displayName: "BinTransferReport",
    routeName: "/BinTransferReport",
    hide: false,
  },
  {
    displayName: "VirtualBinDetail",
    routeName: "/VirtualBinDetail",
    hide: false,
  },
  {
    displayName: "FactTransSync",
    routeName: "/FactTransSync",
    hide: false,
  },
  {
    displayName: "WmsPhysicalStockVariance",
    routeName: "/WmsPhysicalStockVariance",
    hide: false,
  },
];

export const LayoutSideMenuInventory = [
  { displayName: " Physical Stock", routeName: "/PhysicalStock", hide: false },
  {
    displayName: " StockTransferReceipt",
    routeName: "/StockTransferReceipt",
    hide: false,
  },
];

export const LayoutSideMenu = [
  {
    menuName: "Transaction",
    menuList: LayoutSideMenuTransaction,
    hide: LayoutSideMenuTransaction.length === 0 ? true : false,
  },
  {
    menuName: "Inventory",
    menuList: LayoutSideMenuInventory,
    hide: LayoutSideMenuInventory.length === 0 ? true : false,
  },
];
